import { useQuery } from '@apollo/client';

import { NOTIFICATIONS_QUERY } from '../graphql/queries';

/**
 * The signed-in user's notifications, newest first. Scope is forced to the actor server-side.
 * `enabled` gates the fetch to when the bell drawer is open — the panel loads on demand, not on every
 * page. Follows the platform list conventions: `cache-and-network` with a `previousData` fallback so
 * the count/rows don't flash while a refetch is in flight.
 */
export function useNotifications(enabled: boolean) {
  const { data, previousData, loading, error, refetch } = useQuery(NOTIFICATIONS_QUERY, {
    variables: { unreadOnly: false, page: 1, pageSize: 20 },
    fetchPolicy: 'cache-and-network',
    skip: !enabled,
  });

  const list = (data ?? previousData)?.notifications ?? null;

  return {
    notifications: list?.items ?? [],
    totalCount: list?.totalCount ?? 0,
    loading: loading && !data && !previousData,
    error: error ?? null,
    refetch,
  };
}
